import React from 'react'
import { styled } from '@mui/system'
import { Container, Typography, Grid, Button, Tooltip } from '@mui/material'
import { generateUtilityClasses } from '@mui/material'
import { ReactComponent as PrintIcon } from '../../../../../assets/icons/printer.svg'
import { ReactComponent as DownloadIcon } from '../../../../../assets/icons/download_icon.svg'
import { ReactComponent as FilterIcon } from '../../../../../assets/icons/filter_icon.svg'
import { UspReportSalesTaxResult } from '../../../../../models'
import * as XLSX from 'xlsx'
import { convertDateToDisplay } from '../../../../../utils/dateUtils'
import { parseToNumber } from '../../../../../utils/general'

const classes = generateUtilityClasses('Container', ['root', 'titleWrap', 'btnWrap'])

const StyledContainer = styled(Container)(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(1, 3, 1, 3),
    margin: 0,
    display: 'flex',
    backgroundColor: theme.palette.background.main,
    width: '100%',
    maxWidth: 'unset',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  [`& .${classes.titleWrap}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  [`& .${classes.btnWrap}`]: {
    maxWidth: '30px',
    maxHeight: '42px',
    minWidth: '30px',
    minHeight: '42px',
    padding: '3px',
    marginLeft: '10px',
    color: theme.palette.text.primary,
  },
}))

interface Props {
  handleOpenFilterModal: () => void
  filterData: UspReportSalesTaxResult[]
}

export const Header = ({ handleOpenFilterModal, filterData }: Props) => {
  const transformDataForExport = (data: UspReportSalesTaxResult[]) => {
    return data?.map((item: UspReportSalesTaxResult) => ({
      'Stock #': item.StockNumber,
      Buyer: item.Buyer,
      Car: item.Car,
      VIN: item.VIN,
      Deal: convertDateToDisplay(item.Deal),
      Finalized: convertDateToDisplay(item.Finalized),
      Branch: item.Branch,
      'Deal Type': item.DealType,
      'Deal State': item.DealState,
      'Sales Price': parseToNumber(item.SalesPrice),
      'Trade Credit': parseToNumber(item.TradeCredit),
      'Taxable Amount': parseToNumber(item.TaxableAmount),
      'Tax State': item.TaxState,
      'Tax City': item.TaxCityName,
      'Tax County': item.TaxCountyName,
      'State Tax': parseToNumber(item.StateTaxAmount),
      'City Tax': parseToNumber(item.CityTaxAmount),
      'County Tax': parseToNumber(item.CountyTaxAmount),
      'Misc Tax': parseToNumber(item.MiscTaxAmount),
      'State Rate': item.StateTaxRate,
      'City Rate': item.CityTaxRate,
      'County Rate': item.CountyTaxRate,
      'Misc Rate ': item.MiscTaxRate,
    }))
  }

  const setColumnWidths = (worksheet: any) => {
    const columnWidths = [
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ]

    worksheet['!cols'] = columnWidths
  }

  const exportToExcel = (data: any, fileName: any) => {
    const transformedData = transformDataForExport(data)
    const worksheet = XLSX.utils.json_to_sheet(transformedData)
    setColumnWidths(worksheet)

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
    XLSX.writeFile(workbook, `${fileName}.xlsx`)
  }

  return (
    <>
      <Grid container justifyContent={'flex-end'} p={3} alignItems={'center'}>
        <Grid item>
          <Tooltip title='Download'>
            <Button variant='text' className={classes.btnWrap} onClick={() => exportToExcel(filterData, 'Sales Tax')}>
              <DownloadIcon />
            </Button>
          </Tooltip>
        </Grid>
        <Grid item>
          <Tooltip title='Print'>
            <Button variant='text' className={classes.btnWrap}>
              <PrintIcon />
            </Button>
          </Tooltip>
        </Grid>
        <Grid item>
          <Tooltip title='Filter'>
            <Button onClick={handleOpenFilterModal} variant='text' className={classes.btnWrap}>
              <FilterIcon />
            </Button>
          </Tooltip>
        </Grid>
      </Grid>
    </>
  )
}

export default Header
